import React, { useEffect, useState } from 'react';
import { consultarParametrosMunicipio, emitirNotaFiscal } from '../services/faturamentoService';
import DebugToken from './DebugToken';

const EmitirNotaMogi = () => {
  const [parametros, setParametros] = useState(null);
  const [codigoMunicipio, setCodigoMunicipio] = useState('');
  const [status, setStatus] = useState('');
  const [erro, setErro] = useState('');
  const [emitindo, setEmitindo] = useState(false);

  useEffect(() => {
    consultarParametrosMunicipio()
      .then(response => {
        setParametros(response.data.parametros);
        // Tenta pegar o código de Mogi das Cruzes (exemplo: 3530607)
        const codMogi = response.data.parametros?.codigo_municipio || response.data.parametros?.codigoMunicipio || '';
        setCodigoMunicipio(codMogi);
      })
      .catch(error => {
        setErro(error.response?.data?.message || 'Erro ao consultar parâmetros');
      });
  }, []);

  const handleEmitirNota = async () => {
    setEmitindo(true);
    setStatus('');
    setErro('');
    try {
      // Exemplo de payload mínimo, ajuste conforme necessário
      const payload = {
        codigo_municipio: codigoMunicipio,
        // ...outros campos obrigatórios para emissão
      };
      const response = await emitirNotaFiscal(payload);
      setStatus('Nota emitida com sucesso!');
    } catch (error) {
      setErro(error.response?.data?.message || 'Erro ao emitir nota');
    } finally {
      setEmitindo(false);
    }
  };

  return (
    <div>
      <DebugToken />
      <h2>Emissão de Nota Fiscal - Mogi das Cruzes</h2>
      {erro && <div style={{color: 'red'}}>Erro: {erro}</div>}
      {!parametros && !erro && <div>Carregando parâmetros...</div>}
      {parametros && (
        <div>
          <div><strong>Código do Município:</strong> {codigoMunicipio || 'Não encontrado'}</div>
          <button onClick={handleEmitirNota} disabled={emitindo || !codigoMunicipio} style={{marginTop: 16}}>
            {emitindo ? 'Emitindo...' : 'Emitir Nota'}
          </button>
          {status && <div style={{color: 'green', marginTop: 16}}>{status}</div>}
        </div>
      )}
    </div>
  );
};

export default EmitirNotaMogi;
